module.exports = __webpack_public_path__ + "ic-question-mini-gray.svg?9e05a27a254b6db8fce2679d751bf5b4";